import React from "react";

export default function Strongify(chunk: any) {
  return <strong>{chunk}</strong>;
}
